<template>
  <div class="tw-m-8 tw-mb-0">
    <div class="tw-text-2xl tw-mb-2 tw-font-semibold">{{title}}
      <span v-if="required !== false" class="tw-text-red tw-font-bold tw-ml-1">*</span>
    </div>
    <slot></slot>
    <div v-if="error !== false" class="tw-text-red tw-font-bold tw-mt-1">{{error}}</div>
  </div>

</template>
<script>
  export default {
    props: {
      title: {},
      required: {
        default: false
      },
      error: {
        default: false
      },
    },
  }
</script>
<style>
  .tw-form-input:focus, .vue-tel-input:focus-within, .vdpComponent:focus-within{
    @apply tw-shadow tw-border-blue !important;
  }

  .tw-form-input{
    @apply tw-rounded-xl tw-border tw-border-light-4 tw-px-6 tw-py-4 tw-w-full tw-text-xl !important;
  }

  .multiselect__option--highlight {
    @apply bg-secondary !important;
  }

  .multiselect__option--highlight:after {
    @apply bg-primary !important;
  }

  .vti__dropdown{
    @apply tw-p-0 !important;
  }
</style>
